module.exports = __webpack_public_path__ + "img/IMG_8980.8ab29742.jpg";